/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
export class DriverEndorsement{
  driverId:number;
  attachment:string;
  dateValidated: string;
  driverEndorsementId:number;
  expirationDate:string;
  siteId:number;
  siteName:string;
  endorsementDesc: string;
  endorsementId:number;
  endorsementName:string;
}
